import { useState, useEffect } from "react";
import "../../components/LeadDataReport/LeadDataReport.css";
import axios from "axios";
import ExcelExport from "../ExcelExport/ExcelExport";
import filterIcon from "../../Icons/filterIcon.png";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import './PettyCash.css';
import CryptoJS from 'crypto-js';


const PettyCash = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    relocation_id: "",
    request_type: "",
    amount: "",
    remark: "",
    approval_status: "Requested"
  });



  const [leadResponse, setLeadResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [expenseType, setExpenseType] = useState([]);
  const storedToken = JSON.parse(localStorage.getItem("token"));
  const [pettyCashListResponse, setPettyCashListResponse] = useState([]);

  function nextPage(pettycash_id) {      
      const encryptedId = CryptoJS.AES.encrypt(pettycash_id.toString(), 'dbbworldwidepvtltd').toString();
      const url = `/PettyCashDetail?id=${encodeURIComponent(encryptedId)}`;
      window.open(url, '_blank');
    }

  function getStatusColor(status) {
    switch (status) {
      case 'Pending':
        return '#0DCAF0';
      case 'Requested':
        return '#F19C00';
      case 'Rejected':
        return '#DC3545';
      case 'Completed':
        return '#20BF44';
    }
  }

  const handleCancel = () => {
    setShowForm(false);
    setFormData({
      relocation_id: "",
      request_type: "",
      amount: "",
      remark: "",
      approval_status: "Requested"
    });
  };

  const handleAddPettyCash = async (e) => {
    e.preventDefault();
    if (!formData.request_type || !formData.amount) {
      alert("Please fill all required fields");
      return;
    }
    // Here you would typically send the formData to your backend API


    try {

      const headers = {
        Authorization: `Bearer ${storedToken}`, // Replace with your token logic
        "Content-Type": "application/json",
      };

      const response = await axios.post(`${baseAPI}UserPost/InsertUpdateCmpPettyCash`, formData, { headers });

      if (response.status === 200) {
        alert("Expense saved successfully!");
        setShowForm(false);
        fetchPettyCashList(); // Refresh the list after adding a new expense
      } else {
        console.error("Unexpected response:", response);
        alert("Error saving expense!");
      }
    } catch (error) {
      console.error("Error saving expense:", error.response ? error.response.data : error.message);
      alert("Error saving expense!");
    }

    // Close the form
    setShowForm(false);

    // Reset form data
    setFormData({
      relocation_id: "",
      request_type: "",
      amount: "",
      remark: "",
      approval_status: "Requested"
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers = {
          Authorization: `Bearer ${storedToken}`, // Replace with your token logic
          "Content-Type": "application/json",
        };
        const expenseTypeRes = await axios.get(`${baseAPI}adminGet/GetRequestType`, { headers });
        setExpenseType(expenseTypeRes.data.data);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    fetchPettyCashList();
  }, []);


  const fetchPettyCashList = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`, // Replace with your token logic
        "Content-Type": "application/json",
      };

      const pcDetailRes = await axios.get(`${baseAPI}userGet/GetPettyCashDetail?pettycash_id=0&relocation_id=0`, { headers });
      setPettyCashListResponse(pcDetailRes.data.data);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "20px" }}>
        <button className="filterButton">
          <img src={filterIcon} /> FILTER
        </button>
        <div style={{ display: "flex" }}>
          <button onClick={() => setShowForm(true)}
            style={{
              width: "13rem",
              height: "3rem",
              borderRadius: "11.5px",
              marginRight: "10px",
            }}
          >
            <AddIcon className="icon" />
            Request Petty Cash
          </button>
          <ExcelExport leadResponse={leadResponse} />
        </div>
      </div>


      {showForm && (
        <div class="container-1 style1" style={styles1}>
          <div class="row">
            <div class="col-12">
              <h2 class="text-left" style={{ fontSize: "18px", padding: "9px 0 0 16px" }}>Add Petty Cash Request</h2>
            </div>
          </div>
          <div class="row expense-rowms">
            <div class="col-md-4" style={{ display: "flex", flexDirection: "column" }}>
              <label className="label-expenseMs">Lead ID</label>
              <input
                type="number"                
                className="amount-input"
                style={{ height: "54px", borderRadius: "5px", padding: "10px" }}
                value={formData.relocation_id}
                onChange={(e) => setFormData({ ...formData, relocation_id: e.target.value })}
              />
            </div>


            <div class="col-md-4" style={{ display: "flex", flexDirection: "column" }}>
              <label className="label-expenseMs">Request type</label>
              <select
                className="form-control form-control-expencsems Expense-input form-control-expencsems-expense"
                name="request_type"
                style={{ height: "54px", borderRadius: "5px", padding: "10px" }}
                value={formData.request_type}
                onChange={(e) => setFormData({ ...formData, request_type: parseInt(e.target.value) })}
              >
                <option value="">Select</option>
                {expenseType.map((exp) => (
                  <option key={exp.request_type_id} value={exp.request_type_id}>
                    {exp.request_type}
                  </option>
                ))}
              </select>
            </div>
            <div class="col-md-4" style={{ display: "flex", flexDirection: "column" }}>
              <label className="label-expenseMs">Amount</label>
              <input
                type="number"
                placeholder="Amount"
                className="amount-input"
                style={{ height: "54px", borderRadius: "5px", padding: "10px" }}
                value={formData.amount}
                onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
              />
            </div>

          </div>
          <div class="row expense-rowms">
            <div class="col-md-12" style={{ display: "flex", flexDirection: "column" }}>
              <label className="label-expenseMs">Remark</label>
              <textarea
                placeholder="Remark (Optional)"
                value={formData.remark}
                className="label-expense-text Expense-input"
                style={{ borderRadius: "5px", padding: "10px" }}
                onChange={(e) => setFormData({ ...formData, remark: e.target.value })}
              />
            </div>

          </div>
          <div class="row expense-rowms" style={{ textAlign: "end", padding: "16px 15px 0 0" }}>
            <div class="col-md-12">
              <button onClick={handleCancel} style={{ padding: "5px 15px", border: "none", color: "red" }}>Cancel</button>
              <button onClick={handleAddPettyCash} style={{ backgroundColor: "#5B489D", color: "white", padding: "5px 15px" }}>Add</button>
            </div>
          </div>
        </div>
      )}

      <div className="headingLeadReport">
        <p>Petty Cash List</p>
      </div>
      <div
        className="container-fluid"
        style={{ width: "100%", overflowX: "auto" }}
      >

        <div className="petBreedList">
          <table>
            <thead>
              <tr
                className="petBreedListHeading"
                style={{
                  whiteSpace: "nowrap",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <th>Sr. No</th>
                <th>Receipt Number</th>
                <th>Lead ID</th>
                <th>Name</th>
                <th>Date of Request</th>
                <th>Request Type</th>
                <th>Purpose</th>
                <th>Requested Amount</th>
                
                <th>Payment Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {pettyCashListResponse && pettyCashListResponse.length > 0 ?
                pettyCashListResponse.map((item, idx) => {
                  return <tr>
                    <td>{idx + 1}</td>
                    <td>{item.pettycash_id}</td>
                    <td>{item.relocation_id}</td>
                    <td>{item.requested_by_name}</td>
                    <td>{item.request_date}</td>
                    <td>{item.request_type_name}</td>
                    <td>{item.remark}</td>
                    <td>{item.amount}</td>
                    
                    <td >
                      <span style={{ backgroundColor: getStatusColor(item.approval_status), color: 'white', margin: '12px', border: 'none' }}>{item.approval_status}</span>
                    </td>
                    <td>
                      <button
                         onClick={() => nextPage(item.pettycash_id)}
                        style={{
                          height: "30px",
                          width: "38px",
                          backgroundColor: "#5B489D",
                        }}
                      >
                        <SearchIcon className="icon" style={{ color: "white" }} />
                      </button>
                    </td>
                  </tr>
                })
                :
                null}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const styles1 = {


  margin: "0px 0 2rem 0px",
  padding: "1px 0 4rem 0"

}




export default PettyCash;
